import type { TourStepItem } from 'components/shared/GuidedTour/GuidedTour.steps';

/**
 * Steps definition, depending on the location of the user...
 * Be careful to not rename already persisted completed steps
 */
export const dashboardTourStepItems: TourStepItem[] = [
  { id: 'quoteDashboard.button' },
  { id: 'quoteDashboard.search' },
  { id: 'quoteDashboard.menu.byStatus' },
  { id: 'quoteDashboard.tile' },
  { id: 'quoteDashboard.tile.downloadDocs' },
  { id: 'quoteDashboard.tile.refresh' },
  { id: 'quoteDashboard.tile.pin' },
  { id: 'quoteDashboard.tile.redirectToQuoteForm' },
  { id: 'quoteDashboard.tile.delete' },
  { id: 'quoteDashboard.menu.byPinned' },
  { id: 'quoteDashboard.menu.byClient' },
  { id: 'quoteDashboard.menu.byProduct' },
  { id: 'quoteDashboard.deleteGroup' },
];
